import { useCookies } from 'react-cookie';

import { OIDC_USER_AGENT_COOKIE } from '@framework/utils/cookies';

const useIsNativeApps = (): boolean => {
    const [cookies] = useCookies([OIDC_USER_AGENT_COOKIE]);

    return !!cookies?.[OIDC_USER_AGENT_COOKIE];
};

export default useIsNativeApps;
